/* AtmosPure: "Goede keuze"-blok en zekerheden in de winkelwagen, en de klok op de productpagina. Bestel-binnen-klok en verwachte bezorgdatum in Nederlandse tijd. */
(function () {
  if (window.__apcc) return;
  window.__apcc = 1;
  var be = null, asked = false, last = null, timer = 0;
  try { last = sessionStorage.getItem('apcc-k'); } catch (e) {}
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function hhmm(v, d) {
    var m = /^([0-9]{1,2})[:.]([0-9]{2})$/.exec(String(v || '').trim());
    return m ? Math.min(86400, parseInt(m[1], 10) * 3600 + parseInt(m[2], 10) * 60) : d;
  }
  function ams() {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      var wd = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 }[p.weekday];
      if (wd) return { wd: wd, s: (parseInt(p.hour, 10) % 24) * 3600 + parseInt(p.minute, 10) * 60 + parseInt(p.second, 10), y: +p.year, m: +p.month, d: +p.day };
    } catch (e) {}
    var d = new Date();
    return { wd: d.getDay() || 7, s: d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds(), y: d.getFullYear(), m: d.getMonth() + 1, d: d.getDate() };
  }
  function country(el) {
    if ((el.getAttribute('data-cc') || '').toUpperCase() === 'BE') be = true;
    if (be !== null || asked) return;
    asked = true;
    var c = null;
    try { c = sessionStorage.getItem('apcc-be'); } catch (e) {}
    if (c === '1' || c === '0') { be = c === '1'; return; }
    if (!window.fetch) { be = false; return; }
    // land van de bezoeker op basis van het IP-adres (Shopify); niet herkend = Nederlandse besteltijd
    fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var h = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
      be = String(h || '').toUpperCase() === 'BE';
      try { sessionStorage.setItem('apcc-be', be ? '1' : '0'); } catch (e) {}
      tick();
    }).catch(function () { be = false; });
  }
  var DAYS = ['', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag', 'zondag'];
  // Dagen zonder bezorging (officiele feestdagen; aangenomen dat er dan niet bezorgd en niet verwerkt wordt). Bijwerken na half 2027.
  var SKIP_NL = ['2026-12-25', '2026-12-26', '2027-01-01', '2027-03-29', '2027-04-27', '2027-05-06', '2027-05-17', '2027-12-25', '2028-01-01'];
  var SKIP_BE = ['2026-11-11', '2026-12-25', '2027-01-01', '2027-03-29', '2027-05-01', '2027-05-06', '2027-05-17', '2027-07-21', '2027-11-01', '2027-11-11', '2027-12-25', '2028-01-01'];
  function key(n, add) { return new Date(Date.UTC(n.y, n.m - 1, n.d + add, 12)).toISOString().slice(0, 10); }
  function wdOf(n, add) { return (n.wd - 1 + add) % 7 + 1; }
  function skip(n, add) { return (be === true ? SKIP_BE : SKIP_NL).indexOf(key(n, add)) > -1; }
  // geen bezorging op zondag en feestdagen (zaterdag wel: vrijdag besteld is zaterdag in huis)
  function noDelivery(n, add) { return wdOf(n, add) === 7 || skip(n, add); }
  // hoeveel dagen vanaf vandaag de bestelling meetelt (0 = vandaag nog op tijd)
  function orderOffset(days, n, cut) {
    var k = 0;
    if (days.indexOf(n.wd) > -1 && n.s < cut && !skip(n, 0)) return 0;
    do { k++; } while ((days.indexOf(wdOf(n, k)) < 0 || skip(n, k)) && k < 10);
    return k >= 10 ? null : k;
  }
  // eerste dag na de besteldag waarop bezorgd wordt
  function deliveryOffset(n, k) {
    var d = k + 1;
    while (noDelivery(n, d) && d < k + 10) d++;
    return d;
  }
  function fmt(n, add, opt) {
    try { return new Intl.DateTimeFormat('nl-NL', Object.assign({ timeZone: 'UTC' }, opt)).format(new Date(Date.UTC(n.y, n.m - 1, n.d + add, 12))).split('.').join(''); } catch (e) { return ''; }
  }
  function render(el, n) {
    var days = (el.getAttribute('data-days') || '').split(',').map(function (x) { return parseInt(x, 10); });
    var cut = be === true ? hhmm(el.getAttribute('data-cut-be'), 79200) : hhmm(el.getAttribute('data-cut'), 86340);
    var k = n.y ? orderOffset(days, n, cut) : null, dd = k === null ? null : deliveryOffset(n, k);
    // veiligheid: klopt er iets niet (geen datum, of bezorging meer dan 3 dagen weg), dan tonen we geen belofte
    var ok = dd !== null && dd <= 3;
    var live = ok && k === 0 && dd === 1;
    var line = el.querySelector('[data-ap-cc-line]'), t = el.querySelector('[data-ap-cc-t]'), i, x, v;
    if (line && line.hidden === live) line.hidden = !live;
    if (live && t) {
      var s = cut - n.s, txt = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
      if (t.textContent !== txt) t.textContent = txt;
    }
    var off = el.querySelector('[data-ap-cc-off]');
    if (off) {
      if (ok && !live) { v = 'Vandaag besteld, ' + DAYS[wdOf(n, dd)] + ' in huis'; if (off.textContent !== v) off.textContent = v; }
      if (off.hidden === (ok && !live)) off.hidden = !(ok && !live);
    }
    // korte datum achter "morgen" in de klok, bijvoorbeeld (wo 4 nov)
    x = el.querySelectorAll('[data-ap-cc-short]');
    for (i = 0; i < x.length; i++) { v = live ? ' (' + fmt(n, 1, { weekday: 'short', day: 'numeric', month: 'short' }) + ')' : ''; if (x[i].textContent !== v) x[i].textContent = v; }
    // volledige verwachte bezorgdatum, bijvoorbeeld maandag 2 november
    x = el.querySelectorAll('[data-ap-cc-date]');
    for (i = 0; i < x.length; i++) {
      v = ok ? fmt(n, dd, { weekday: 'long', day: 'numeric', month: 'long' }) : '';
      if (x[i].textContent !== v) x[i].textContent = v;
      var row = x[i].closest('[data-ap-cc-row]'); if (row) row.hidden = !v;
    }
  }
  function tick() {
    var els = document.querySelectorAll('[data-ap-cc]');
    if (!els.length) return;
    var n = ams();
    for (var i = 0; i < els.length; i++) render(els[i], n);
  }
  function prep() {
    var els = document.querySelectorAll('[data-ap-cc]'), fresh = [], i, k, seen = last;
    for (i = 0; i < els.length; i++) if (!els[i].__apcc) { els[i].__apcc = 1; fresh.push(els[i]); }
    if (!fresh.length) return;
    var n = ams();
    for (i = 0; i < fresh.length; i++) {
      country(fresh[i]);
      k = fresh[i].getAttribute('data-key') || '';
      // animatie alleen als er een ander product bovenaan staat dan de vorige keer
      if (k && k !== seen) fresh[i].classList.add('is-new');
      if (k) last = k;
      render(fresh[i], n);
    }
    try { if (last) sessionStorage.setItem('apcc-k', last); } catch (e) {}
  }
  function loop() {
    tick();
    clearTimeout(timer);
    timer = setTimeout(loop, 1005 - (Date.now() % 1000));
  }
  function start() {
    prep();
    if (window.MutationObserver) new MutationObserver(prep).observe(document.documentElement, { childList: true, subtree: true });
    loop();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();